import { createContext, useContext } from 'react'
import { NOT_WATCHED_STATE } from './visionState'

// Story 213 v2 — what the guard tells the sensitive boundaries below it (C7.1). Outside a guard nothing is
// covered and a boundary just shows its content.
export const VisionContext = createContext({
  state: NOT_WATCHED_STATE,
  cameraFailure: '',
  markedScreens: [],
  // frontEndConfig.vision.enabled says vision is on (C11.3, H-1); with it off there are no locks nor marking for anyone
  // (DB-6). It paints nothing in the top bar by itself: the camera icon shows only with a vigilance (S217, PO 2026-10-22).
  visionEnabled: false,
  // Whether a protected piece is hidden now: the vigilance covers it, or the session is not watched and the setting says
  // protected content is not shown without vigilance (C16.10, RN147). Every piece (boundary, row, thumbnail) reads this.
  protectedHidden: false,
  // The route whose screen only knew it was protected by a 423 while waiting with the setting NO: its content is the
  // placeholder (ProtectedRouteContent, S336). '' when none.
  blurredPath: '',
  registerBoundary: () => () => {},
  back: () => {}
})

export const useVision = () => useContext(VisionContext)

// Whether a protected piece is hidden now (a boundary, a row, a thumbnail): covered by the vigilance, or the guard says the
// session is not watched and protected content is not shown without vigilance (C16.10).
export const useProtectedHidden = () => {
  const { state, protectedHidden } = useVision()
  return protectedHidden === true || state.covered === true
}
